import React from 'react';
import '../styles/InfoCard.css';

export default function InfoCard({ direccion, telefono, email }) {
  return (
    <div className="info-card">
      <h3 className="info-card-title">Información General</h3>
      <ul className="info-card-list">
        <li>
          <i className="fas fa-map-marker-alt info-icon"></i>
          <div className="info-text">
            <strong>Dirección</strong>
            <span>{direccion || 'No disponible'}</span>
          </div>
        </li>
        <li>
          <i className="fas fa-phone-alt info-icon"></i>
          <div className="info-text">
            <strong>Teléfono</strong>
            <span>{telefono || 'No disponible'}</span>
          </div>
        </li>
        <li>
          <i className="fas fa-envelope info-icon"></i>
          <div className="info-text">
            <strong>Email</strong>
            <span>{email || 'No disponible'}</span>
          </div>
        </li>
      </ul>
    </div>
  );
}